const t = "Nhấn Enter để chỉnh sửa", s = {
  pressEnterToEdit: t
};
export {
  s as default,
  t as pressEnterToEdit
};
